const DEFAULT_MAX_ATTEMPTS = 20

export type AnimationFrameRetry = { cancel: () => void }

type AnimationFrameRetryArgs = {
  attempt: () => boolean
  onExhausted?: () => void
  maxAttempts?: number
}

export const retryOnAnimationFrames = ({
  attempt,
  onExhausted,
  maxAttempts = DEFAULT_MAX_ATTEMPTS,
}: AnimationFrameRetryArgs): AnimationFrameRetry => {
  let frame: number | null = null
  let attemptsLeft = maxAttempts

  const tick = (): void => {
    frame = null
    if (attempt()) return
    attemptsLeft -= 1
    if (attemptsLeft > 0) {
      frame = requestAnimationFrame(tick)
      return
    }
    onExhausted?.()
  }

  frame = requestAnimationFrame(tick)

  return {
    cancel: (): void => {
      if (frame === null) return
      cancelAnimationFrame(frame)
      frame = null
    },
  }
}
